<h2>{{ 'global-forms.device.title' | translate }}</h2>

<form id="form" class="details-form" (ngSubmit)="onSubmit(form)" [formGroup]="form" novalidate>
  <mat-slide-toggle color="primary" formControlName="superDeviceControl" [labelPosition]="'before'" class="toggle" *ngIf="isSuperAdmin">
    {{ 'devices.creating-form.SuperDeviceControl' | translate }}
  </mat-slide-toggle>
  <br />

  <div class="form-row" *ngIf="!superDeviceControl.value">
    <mat-form-field>
      <input
        formControlName="companySlug"
        type="text"
        [placeholder]="'teams.form.CompanySlug' | translate"
        required
        matInput
        [matAutocomplete]="auto"
        autocomplete="off"
        [matAutocompleteDisabled]="isCompanyAdmin || isTeamAdmin"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayCompanyProperty.bind(this)"
        (optionSelected)="setCompanyValue($event)"
      >
        <mat-option *ngFor="let company of companiesFiltered | async" [value]="company.Slug">
          {{ company.Name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="shouldShowCompanySlugError">
        {{ 'validation.required' | translate: { name: ('teams.form.CompanySlug' | translate) } }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field class="team-slug" *ngIf="!superDeviceControl.value">
      <input
        formControlName="teamSlugControl"
        type="text"
        [placeholder]="'sidebar.teams' | translate"
        matInput
        [matAutocomplete]="auto"
        autocomplete="off"
        required
        [matAutocompleteDisabled]="isTeamAdmin"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayTeamProperty.bind(this)">
        <mat-option *ngFor="let team of teamsFiltered | async" [value]="team.Slug">
          {{ getTeamDisplayValue(team) }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field>
      <input matInput formControlName="email" name="email" placeholder="{{ 'devices.creating-form.Email' | translate }}" required />
      <mat-error *ngIf="shouldShowEmailError">
        {{ 'validation.required' | translate: { name: ('devices.creating-form.Email' | translate) } }}
      </mat-error>
    </mat-form-field>
  </div>
  <div class="buttons">
    <button mat-ripple class="cancel-button" (click)="cancel()" type="button">{{ 'global-forms.device.cancel' | translate }}</button>
    <button mat-ripple class="apply-button" type="submit">{{ 'global-forms.device.add' | translate }}</button>
  </div>
</form>
